enum AuthErrorCode {
    INVALID = 255,
    VALID = 0,
    EXISTS = 250,
    DEFAULT = -1
}

export default AuthErrorCode;
